/* AE PDP — Gallery carousel arrows + enhancements */
(function () {
  'use strict';

  function initGalleryArrows() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const sliderWrap = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (!sliderWrap) return;

    const sliderList = sliderWrap.querySelector('.product__media-list');
    if (!sliderList) return;

    function getSlides() {
      return Array.from(sliderList.querySelectorAll('.product__media-item[data-media-id]'));
    }

    function getActiveIndex() {
      const slides = getSlides();
      const idx = slides.findIndex(s => s.classList.contains('is-active'));
      return idx >= 0 ? idx : 0;
    }

    function goTo(index) {
      const slides = getSlides();
      if (!slides.length) return;
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      const mediaId = slides[index].dataset.mediaId;
      if (mediaId && gallery.setActiveMedia) {
        gallery.setActiveMedia(mediaId, false);
      }
    }

    // Build prev button
    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'ae-arrow ae-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

    // Build next button
    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'ae-arrow ae-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    sliderWrap.appendChild(prevBtn);
    sliderWrap.appendChild(nextBtn);

    prevBtn.addEventListener('click', function () { goTo(getActiveIndex() - 1); });
    nextBtn.addEventListener('click', function () { goTo(getActiveIndex() + 1); });

    // Hide arrows if only 1 image
    function updateArrowVisibility() {
      const count = getSlides().length;
      const hidden = count <= 1;
      prevBtn.style.display = hidden ? 'none' : '';
      nextBtn.style.display = hidden ? 'none' : '';
    }
    updateArrowVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }
})();
